// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1FncD","legacyBtn":"MutateMid_legacyBtn__3O2LD"};